const ArrowUpRed = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
    <path
      d="M1.69519 10.0937L7.6952 4.09367L7.6952 16.7949H10.0952L10.0952 4.09367L16.0952 10.0937L17.7939 8.39867L9.74644 0.351173C9.27769 -0.117577 8.51645 -0.117577 8.0477 0.351173L0.00019455 8.39867L1.69519 10.0937Z"
      fill="#F05252"
    />
  </svg>
);

export default ArrowUpRed;
